import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { AddNewUser, GetProcessList, GetUserDetails, UpdateUserDetails } from '../../models/process';
import { pnkstore } from '../../stores/pnk-store';
import { useUserStore } from '../../stores/user-store';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { GetAllProject, GetAreasList, GetCitiesList, GetDistrictList, GetStatesList } from '../../models/project';
import { AddNewInstitute, AddNewLead, AddNewStudent, GetAllInstitutes, GetAllLeads, GetStudentList, UpdateInstitute, UpdateInstituteDesc, UpdateLead, UpdateLeadDesc, UpdateStudent, UpdateStudentDesc } from '../../models/leads';
import { GetProfileList } from '../../models/profile';
import { GetUserList } from '../../models/user';
import { AgreementDetailsComp } from './agreementdetails';
import { AddNewAgreement, GetAllAgreement, UpdateAgreement } from '../../models/agreement';

export const AgreementDetails = () => {
    const userData = useUserStore;
    const [FormData, setFormData] = useState({
        'txtCompanyName': 'UPRN Private Limited',
        'txtCompanyRepresentativeName': 'Puneet Kinra',
        'txtCompanyRepresentativeEmail': 'puneet@uprn.in',
        'txtCompanyRepresentativeDesignation': 'Director',
        'txtCompanyAddress': '401 Ranka Park, Richmond Circle, Lalbagh Road, Bangalore - 560027',
        'txtReferralFee': '59,320',
    });
    const [agreementSearchObj, setAgreementSearchObj] = useState({});
    const [getAgreementDetails, setGetAgreementDetails] = useState(false);
    const [agreementDetails, setAgreementDetails] = useState([]);
    const [setNo, setSetNo] = useState(1);
    const [perSet, setPerSet] = useState(20);
    const [mode, setMode] = useState('add');
    const [addAgreement, setAddAgreement] = useState(false);
    const [editAgreement, setEditAgreement] = useState(false);

    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertMsg, setAlertMsg] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    const state = {
        userData: userData.getState(),
        mode: mode,
        addUser: addAgreement,
        editUser: editAgreement,
        showAlert: showAlert,
        alertMsg: alertMsg,
        alertType: alertType,

    }

    useEffect(() => {
        let agreement_id = params.agreement_id;
        if (agreement_id !== undefined && agreement_id !== null && agreement_id !== '' && agreement_id !== 'new') {
            setMode('edit');
            setAgreementSearchObj({
                'txtAgreementId': agreement_id
            })
            setGetAgreementDetails(true);
            setFormData((prev) => ({ ...prev, ['txtAgreementId']: agreement_id }));
        }
        else {

        }
    }, []);


    const HandleCheckBox = (e, name) => {
        if (FormData[name] === true) {
            setFormData((prev) => ({ ...prev, [name]: false }));
        }
        else {
            setFormData((prev) => ({ ...prev, [name]: true }));
        }
    }

    const HandleInputs = (e, name) => {

        let value = '';

        if (
            name === 'txtDathhe'
        ) {
            value = e.$d;
           //  alert(value)
            value = new Date(new Date(value).getTime() - (new Date(value).getTimezoneOffset() * 60000)).toISOString().substr(0, 10).replace('T', ' ')
        }
        else {
           
            value = e.target.value;
        }

        // Referral Fee - allow numbers only
        if (name === 'txtReferralFee') {

            value = value
                .replace(/[^0-9]/g, '');

            setAddAgreement(false);
        }

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };




    const SaveOrUpdateAgreement = () => {

        let emailRegex =
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        /* =========================
           REFERRAL PARTNER
        ========================== */

        if (
            !FormData.txtReferralPartnerCompanyName ||
            FormData.txtReferralPartnerCompanyName.trim() === ''
        ) {
            setFormData((prev) => ({
                ...prev,
                txtReferralPartnerCompanyNameErr:
                    'Please Enter Referral Partner / Company Name'
            }));
            return false;
        } else {
            setFormData((prev) => ({
                ...prev,
                txtReferralPartnerCompanyNameErr: ''
            }));
        }




        if (
            !FormData.txtReferralPartnerRepresentativeName ||
            FormData.txtReferralPartnerRepresentativeName.trim() === ''
        ) {
            setFormData((prev) => ({
                ...prev,
                txtReferralPartnerRepresentativeNameErr:
                    'Please Enter Representative Name'
            }));
            return false;
        } else {
            setFormData((prev) => ({
                ...prev,
                txtReferralPartnerRepresentativeNameErr: ''
            }));
        }


        if (
            !FormData.txtReferralPartnerRepresentativeEmail ||
            FormData.txtReferralPartnerRepresentativeEmail.trim() === ''
        ) {
            setFormData((prev) => ({
                ...prev,
                txtReferralPartnerRepresentativeEmailErr:
                    'Please Enter Representative Email'
            }));
            return false;
        }
        else if (
            !emailRegex.test(
                FormData.txtReferralPartnerRepresentativeEmail.trim()
            )
        ) {
            setFormData((prev) => ({
                ...prev,
                txtReferralPartnerRepresentativeEmailErr:
                    'Please Enter Valid Email'
            }));
            return false;
        }
        else {
            setFormData((prev) => ({
                ...prev,
                txtReferralPartnerRepresentativeEmailErr: ''
            }));
        }


        if (
            !FormData.txtReferralPartnerRepresentativeDesignation ||
            FormData.txtReferralPartnerRepresentativeDesignation.trim() === ''
        ) {
            setFormData((prev) => ({
                ...prev,
                txtReferralPartnerRepresentativeDesignationErr:
                    'Please Enter Representative Designation'
            }));
            return false;
        } else {
            setFormData((prev) => ({
                ...prev,
                txtReferralPartnerRepresentativeDesignationErr: ''
            }));
        }

        if (
            !FormData.txtReferralPartnerOfficeAddress ||
            FormData.txtReferralPartnerOfficeAddress.trim() === ''
        ) {
            setFormData((prev) => ({
                ...prev,
                txtReferralPartnerOfficeAddressErr:
                    'Please Enter Office Address'
            }));
            return false;
        } else {
            setFormData((prev) => ({
                ...prev,
                txtReferralPartnerOfficeAddressErr: ''
            }));
        }



        /* =========================
           REFERRAL FEE
        ========================== */

        /* =========================
          AGREEMENT INFORMATION
       ========================== */

        if (
            !FormData.txtDate ||
            FormData.txtDate.trim() === ''
        ) {
            setFormData((prev) => ({
                ...prev,
                txtDateErr: 'Please Select Date'
            }));
            return false;
        } else {
            setFormData((prev) => ({
                ...prev,
                txtDateErr: ''
            }));
        }




        if (
            !FormData.txtReferralFee ||
            FormData.txtReferralFee.trim() === ''
        ) {
            setFormData((prev) => ({
                ...prev,
                txtReferralFeeErr:
                    'Please Enter Referral Fee'
            }));
            return false;
        } else {
            setFormData((prev) => ({
                ...prev,
                txtReferralFeeErr: ''
            }));
        }


        /* =========================
           SAVE / UPDATE
        ========================== */

        console.log(
            'AGREEMENT DATA => ',
            FormData
        );


        if (mode === 'add') {

            setAddAgreement(true);

        } else {

            setEditAgreement(true);

        }

    };









    const HandleAddNewAgreementResponse = (res) => {
        setAddAgreement(false);
        if (res != false) {
            console.log(res.data.agreementresponse.message.value);
            NavigateTo('agreements');
        }
        else {
            setShowAlert(true);
            setAlertType('error')
            setAlertMsg('Some Error Please Try Again');
        }
    }

    const NavigateTo = (route) => {
        navigate('/' + route, {});
    }

    const HandleGetAgreementListSuccessResponse = (res) => {
        if (res != false && res != 'error') {

            setAgreementDetails(res.data.agreementlistresponse.rows);

            BindAgreementDetails(res.data.agreementlistresponse.rows[0]);
        }
        else {
            setAgreementDetails([]);
        }
        setGetAgreementDetails(false);
    }

   const BindAgreementDetails = (agreementData) => {

    setFormData((prev) => ({
        ...prev,

        // AGREEMENT DETAILS
        txtDate:
            agreementData.agreement_date || '',

        txtMonth:
            agreementData.agreement_month || '',

        // COMPANY INFORMATION
        txtCompanyName:
            agreementData.company_name || '',

        txtCompanyAddress:
            agreementData.company_address || '',

        txtCompanyRepresentativeName:
            agreementData.company_representative_name || '',

        txtCompanyRepresentativeEmail:
            agreementData.company_representative_email || '',

        txtCompanyRepresentativeDesignation:
            agreementData.company_representative_designation || '',

        txtCompanyRepresentativeSignature:
            agreementData.company_representative_signature || '',

        txtCompanySignatureDate:
            agreementData.company_signature_date || '',

        // REFERRAL PARTNER INFORMATION
        txtReferralPartnerCompanyName:
            agreementData.referral_partner_company_name || '',

        txtReferralPartnerOfficeAddress:
            agreementData.referral_partner_office_address || '',

        txtReferralPartnerRepresentativeName:
            agreementData.referral_partner_representative_name || '',

        txtReferralPartnerRepresentativeEmail:
            agreementData.referral_partner_representative_email || '',

        txtReferralPartnerRepresentativeDesignation:
            agreementData.referral_partner_representative_designation || '',

        txtReferralPartnerRepresentativeSignature:
            agreementData.referral_partner_representative_signature || '',

        txtReferralPartnerSignatureDate:
            agreementData.referral_partner_signature_date || '',

        // AGREEMENT FEE
        txtReferralFee:
            agreementData.referral_fee || ''
    }));
};

    const HandleCloseAlertMsg = (type) => {
        setTimeout(() => {
            setShowAlert(false);
            setAlertType('');
            setAlertMsg('');

        }, 3000)

    }

    const HandleUpdateAgreementResponse = (res) => {
        //  console.log(res);

        if (res != false) {
            setGetAgreementDetails(true);
            setShowAlert(true);
            setAlertType('success')
            setAlertMsg(res.data.agreementupdateresponse.message.value);
        }
        else {
            setShowAlert(true);
            setAlertType('error')
            setAlertMsg('Please Try Again');
        }

        setEditAgreement(false);
    }



    return (
        <Box>
            <AgreementDetailsComp
                mystate={state}
                HandleInputs={HandleInputs}
                HandleCheckBox={HandleCheckBox}
                NavigateTo={NavigateTo}
                FormData={FormData}
                SaveOrUpdateAgreement={SaveOrUpdateAgreement}
                HandleCloseAlertMsg={HandleCloseAlertMsg}
            />
            {((addAgreement === true) ? AddNewAgreement(pnkstore, FormData, userData.getState().token, HandleAddNewAgreementResponse) : "")}
            {((editAgreement === true) ? UpdateAgreement(pnkstore, FormData, userData.getState().token, HandleUpdateAgreementResponse) : "")}
            {((getAgreementDetails === true) ? GetAllAgreement(pnkstore, agreementSearchObj, userData.getState().token, HandleGetAgreementListSuccessResponse) : "")}
        </Box>
    )
}